import * as Constants from "../common/Constants";

const initialState = {
    userLogs:[],
    journalLogs: [],
    accountLogs: [],
    salesInvoiceLogs: [],
    filteredUsers: [],
    isLoading: false,
    count: 0,
    page: 1,
    pageSize: 10,
    error: null
};

export default function userReducer(state = initialState, action) {

    switch (action.type) {

        case Constants.REQUEST_GET_JOURNAL_LOG:
        case Constants.REQUEST_GET_ACCOUNT_LOG:
        case Constants.REQUEST_GET_SALES_INVOICE_LOG:
        case Constants.REQUEST_GET_USER_LOG:
            var newState = { ...state };
            newState.error = null;
            newState.isLoading = true;
            //newState.filteredUsers = action.filteredUsers;
            return newState;

        case Constants.SUCCESS_GET_JOURNAL_LOG:
            var newState = { ...state };
            newState.isLoading = false;
            newState.error = null;
            newState.journalLogs = action.journalLogs;
            if (action.journalLogs) {
                newState.journalLogs = action.journalLogs;
                newState.page = action.journalLogs.page;
                newState.pageSize = action.journalLogs.pageSize;
                newState.count = action.journalLogs.totalCount;
            }
            return newState;

        case Constants.SUCCESS_GET_ACCOUNT_LOG:
            var newState = { ...state };
            newState.isLoading = false;
            newState.error = null;
            if (action.accountLogs) {
                newState.accountLogs = action.accountLogs;
                newState.page = action.accountLogs.page;
                newState.pageSize = action.accountLogs.pageSize;
                newState.count = action.accountLogs.totalCount;
            }
            return newState;

        case Constants.SUCCESS_GET_SALES_INVOICE_LOG:
            
            var newState = { ...state };
            newState.isLoading = false;
            newState.error = null;
            if (action.salesInvoiceLogs) {
                newState.salesInvoiceLogs = action.salesInvoiceLogs;
                newState.page = action.salesInvoiceLogs.page;
                newState.pageSize = action.salesInvoiceLogs.pageSize;
                newState.count = action.salesInvoiceLogs.totalCount;
            }
            return newState;


        case Constants.SUCCESS_GET_USER_LOG:

            var newState = { ...state };
            newState.isLoading = false;
            newState.error = null;
            if (action.userLogs) {
                newState.userLogs = action.userLogs;
                newState.page = action.userLogs.page;
                newState.pageSize = action.userLogs.pageSize;
                newState.count = action.userLogs.totalCount;
            }
            return newState;

        case Constants.FAILED_GET_ACCOUNT_LOG:
        case Constants.FAILED_GET_JOURNAL_LOG:
        case Constants.FAILED_GET_SALES_INVOICE_LOG:
        case Constants.FAILED_GET_USER_LOG:
            var newState = { ...state };
            newState.isLoading = false;
            newState.error = action.error;
            return newState;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/LogReducer.js